import { injectable } from "tsyringe";
import { ISimLookupRepository } from "../repositories/ISimLookupRepository";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { SimLookupRequestModel } from "features/simStatusLookup/data/model/SimLookupRequestModel";
import { SimLookupResponseModel } from "features/simStatusLookup/data/model/SimLookupResponseModel";
import { SimLookupInjection } from "features/simStatusLookup/di/SimLookupInjection";

@injectable()
export class SimLookupUseCase {
  private simLookupRepo: ISimLookupRepository;

  constructor() {
    this.simLookupRepo = SimLookupInjection.getRepo();
  }

  async viewSim(
    params: SimLookupRequestModel
  ): Promise<BaseApiResponseModel<SimLookupResponseModel>> {
    return await this.simLookupRepo.viewSim(params);
  }
}